import React from 'react'
import ReactDOMServer from 'react-dom/server'
import Group from '@material-ui/icons/Group'
import { Link } from '@material-ui/core'

const createSteps = (tourSteps, translate) => {
  const iconGroup = ReactDOMServer.renderToString(
    <Group style={{ fontSize: '2rem', verticalAlign: 'middle' }} />,
  )

  const tourLink = (url, text) => ReactDOMServer.renderToString(<Link href={url}>{text}</Link>)

  const steps = {
    hint: [
      {
        element: document.querySelector('#orgName'),
        title: translate('ra.tour.didYouKnow'),
        intro: `You can ${tourLink('/orgUsers', 'invite users')} to your organisation!`,
      },
    ],
    calendar: [
      {
        title: `<img src="logo.png"/> ${translate('ra.tour.welcome')}`,
        intro: translate('ra.tour.welcomeIntro'),
      },
      {
        element: document.querySelector('#orgName'),
        title: translate('ra.tour.organisation'),
        intro: translate('ra.tour.orgIntro'),
        position: 'left',
      },
      {
        element: document.querySelector('#orgLogo'),
        title: translate('ra.tour.logo'),
        intro: translate('ra.tour.logoIntro'),
        position: 'right',
      },
      {
        element: document.querySelector('#players'),
        title: translate('ra.tour.roster'),
        intro: translate('ra.tour.rosterIntro'),
        position: 'right',
      },
    ],
    rosterManagementEmpty: [
      {
        title: `${iconGroup} ${translate('ra.tour.rosterMan')}`,
        intro: translate('ra.tour.rosterManIntro'),
      },
      {
        element: document.querySelector('#playerList'),
        title: translate('ra.tour.playerList'),
        intro: translate('ra.tour.playerListIntro'),
      },
      {
        element: document.querySelector('#addPlayer'),
        title: translate('ra.tour.addPlayer'),
        intro: translate('ra.tour.addPlayerIntro'),
      },
    ],
  }

  return steps[tourSteps]
}

export default createSteps
